<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="160px">
            <el-form-item label="角色名称:" prop="name">
                <el-input v-model="dataForm.name" placeholder="角色名称"></el-input>
            </el-form-item>
            <el-form-item label="角色代码:" prop="roleCode">
                <el-input v-model="dataForm.roleCode" placeholder="角色代码"></el-input>
            </el-form-item>
            <el-form-item label="排序:" prop="sort">
                <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
            </el-form-item>
            <el-form-item label="内置角色" prop="internalRoleId">
                <el-select v-model="dataForm.internalRoleId" placeholder="内置角色"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in internalRoleOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="enabled">
                <el-select v-model="dataForm.enabled" placeholder="状态"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="描述:" prop="remark">
                <el-input type="textarea" v-model="dataForm.remark" placeholder="描述"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    appId: '',
                    name: "",
                    sort: 10,
                    roleCode: "",
                    enabled: true,
                    internalRoleId: '',
                    remark: '',
                },
                internalRoleOptions: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                rules: {
                    name: [
                        {required: true, message: '角色名称不能为空', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            resetForm() {
                this.$refs['dataForm'].resetFields();
            },
            init(id, appId) {
                this.dataForm.id = id || ''
                this.dataForm.appId = appId
                this.visible = true
                this.$nextTick(() => {
                    this.resetForm()
                })
                this.$http.post(`/auth/role/findByAppId?appId=` + appId, {}).then(({data}) => {
                    console.log(data)
                    if (data) {
                        this.internalRoleOptions = data.data
                        this.internalRoleOptions.unshift({id:'',name:'请选择',roleName:'请选择'})
                        console.log(this.internalRoleOptions)
                    } else {
                        this.internalRoleOptions = []
                    }
                })
                if (!this.dataForm.id) {
                    return
                }
                this.$http.post(`/auth/role/getRoleInfo?roleid=` + id, {}).then(({data}) => {
                    this.dataForm = data.data
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return
                    }
                    this.dataSubmit()
                })
            },
            // 表单提交
            dataSubmit() {
                this.$http({
                    url: '/auth/role/saveOrUpdateRole',
                    method: 'post',
                    data: this.dataForm
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-select {
        width: 100%;
    }
</style>
